import { render, staticRenderFns } from "./ModalDeliveryCompleteComponent.vue?vue&type=template&id=315aa1f8&scoped=true"
import script from "./ModalDeliveryCompleteComponent.vue?vue&type=script&lang=js"
export * from "./ModalDeliveryCompleteComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalDeliveryCompleteComponent.vue?vue&type=style&index=0&id=315aa1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315aa1f8",
  null
  
)

export default component.exports